import React, { useCallback, useEffect, useState } from 'react'
import { DotButton, useDotButton } from '@/react-components/BannerCarousel/carouselDotButton'
import Autoplay from 'embla-carousel-autoplay'
import useEmblaCarousel from 'embla-carousel-react'
import "@/assets/bannerCarousel.css";


/**
 * バナーカルーセル表示用コンポーネント
 */
const BannerCarousel = (props) => {
  const { slides, delay, options } = props
  const [emblaRef, emblaApi] = useEmblaCarousel(options, [
    Autoplay({ delay: delay, stopOnInteraction: false })
  ])

  /**
   *  Preview & Nextボタン制御
   */
  const usePrevNextButtons = (emblaApi, onButtonClick) => {
    const [prevBtnDisabled, setPrevBtnDisabled] = useState(true)
    const [nextBtnDisabled, setNextBtnDisabled] = useState(true)

    const onPrevButtonClick = useCallback(() => {
      if (!emblaApi) return
      emblaApi.scrollPrev()
      if (onButtonClick) onButtonClick(emblaApi)
    }, [emblaApi, onButtonClick])

    const onNextButtonClick = useCallback(() => {
      if (!emblaApi) return
      emblaApi.scrollNext()
      if (onButtonClick) onButtonClick(emblaApi)
    }, [emblaApi, onButtonClick])

    const onSelect = useCallback((emblaApi) => {
      setPrevBtnDisabled(!emblaApi.canScrollPrev())
      setNextBtnDisabled(!emblaApi.canScrollNext())
    }, [])

    useEffect(() => {
      if (!emblaApi) return

      onSelect(emblaApi)
      emblaApi.on('reInit', onSelect).on('select', onSelect)
    }, [emblaApi, onSelect])

    return {
      prevBtnDisabled,
      nextBtnDisabled,
      onPrevButtonClick,
      onNextButtonClick
    }
  }

  /**
  * インジケータボタン押下時の自動ローテーション制御
  */
  const onNavButtonClick = useCallback((emblaApi) => {
    const autoplay = emblaApi?.plugins()?.autoplay
    if (!autoplay) return

    const resetOrStop =
      autoplay.options.stopOnInteraction === false
        ? autoplay.reset
        : autoplay.stop

    resetOrStop()
  }, [])

  /**
  * インジケーターイベントハンドラー
  */
  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(
    emblaApi,
    onNavButtonClick
  )

  /**
  * Preview & Nextボタンイベントハンドラー
  */
  const {
    prevBtnDisabled,  /*previewボタンのdisable制御自体は実装しているが現状未使用*/
    nextBtnDisabled,  /*nextボタンのdisable制御自体は実装しているが現状未使用*/
    onPrevButtonClick,
    onNextButtonClick
  } = usePrevNextButtons(emblaApi, onNavButtonClick)

  return (
    <div className="carousel">
      <button className="carousel__button carousel__button--prev" onClick={onPrevButtonClick}></button>
      <div className="embla" ref={emblaRef}>
        <div className="embla__container">
          {slides}
        </div>

        <div className="embla__controls">
          <div className="embla__dots">
            {scrollSnaps.map((_, index) => (
              <DotButton
                key={index}
                onClick={() => onDotButtonClick(index)}
                className={'embla__dot'.concat(
                  index === selectedIndex ? ' embla__dot--selected' : ''
                )}
              />
            ))}
          </div>
        </div>
      </div>
      <button className="carousel__button carousel__button--next" onClick={onNextButtonClick}></button>
    </div>
  )
}

export default BannerCarousel
